module.exports = __webpack_public_path__ + "img/rabbit of good fortune.8197e21d.png";